// lib/vote-gesture.ts
//
// Module-level flag (client-side only) tracking whether a hold-to-vote or
// hold-to-undo gesture is currently in flight, or a vote/undo is pending on
// the server. Read by update-checker.tsx so the "New Update Available"
// popup never interrupts an in-progress vote — it just waits for the next
// poll tick instead. Set by vote-buttons.tsx and pending-vote-display.tsx.
//
// Deliberately a plain module variable, not React context: the writers and
// the one reader (a singleton mounted in the root layout) don't share a
// subtree, and gesture state changes many times per second during a hold
// (16ms fill-bar ticks) — far too hot a path to push through context/state.

let active = false;

export function setVoteGestureActive(value: boolean): void {
  active = value;
}

export function isVoteGestureActive(): boolean {
  return active;
}
